module.exports = __webpack_public_path__ + "img/panel12.be54e78e.jpg";